module.exports = __webpack_public_path__ + "img/Object-E.04f85402.png";